import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import '@nearpod-packages/base-styles/dist/css/fonts.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import * as Sentry from '@sentry/browser'
import { sentryConfigs, getSentryVersion } from './helpers/sentry/sentry'
import * as arrayPrototypeFind from 'array.prototype.find'

const head = document.getElementsByTagName('head')[0]
const linkElement = document.createElement('link')
linkElement.setAttribute('rel', 'stylesheet')
linkElement.setAttribute('href', 'https://fonts.googleapis.com/css?family=Bubblegum+Sans&amp;subset=latin-ext')
head.appendChild(linkElement)

Sentry.init({
	dsn: sentryConfigs.DSN,
	environment: sentryConfigs.ENV,
	release: getSentryVersion(),
	defaultIntegrations: false,
	// Sentry v11 collects broadly by default; keep the restrictive v10 behavior
	dataCollection: {
		userInfo: false,
		cookies: false,
		httpHeaders: false,
		httpBodies: [],
		urlQueryParams: false,
	},
})

arrayPrototypeFind.shim()

createRoot(document.getElementById('root') as HTMLElement).render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
